import Container from 'react-bootstrap/Container';
import AppButton from '../atoms/AppButton';
import { IconArrowRight, IconCheckCircle, IconWhatsapp } from '../atoms/Icon';
import { cta, heroi } from '../content/site';
import { trackEvent } from '../utils/analytics';
import useViewOnce from '../hooks/useViewOnce';

/**
 * A primeira tela. Só o texto e a chamada, sem o quadro de pedidos abaixo —
 * o mesmo mockup continua aparecendo na seção "Painel", então nada de prova
 * do produto se perde, só sai do herói. Um herói sem imagem pesa mais na
 * mensagem e faz esta tela ler como cartaz, não como screenshot.
 *
 * O `<h1>` é o título do herói e não o nome do produto: o nome está no logo, e
 * quem chega aqui por um anúncio precisa ler o que o produto FAZ, não como ele
 * se chama.
 */
function Hero() {
  const ref = useViewOnce('view_hero');

  return (
    <header className="hero on-purple" id="topo" ref={ref}>
      <Container className="shell">
        <div className="hero-content mx-auto">
          <span className="hero-badge">
            <span className="hero-badge-dot" />
            {heroi.selo}
          </span>

          <h1 className="hero-title">
            {heroi.titulo.antes}
            <span className="hero-title-brand">{heroi.titulo.marca}</span>
            {heroi.titulo.meio}
            <mark>{heroi.titulo.destaque}</mark>
          </h1>

          <p className="hero-lead mx-auto">{heroi.texto}</p>

          <div className="hero-actions justify-content-md-center">
            <AppButton
              href={cta.principal.href}
              variant="whatsapp"
              size="lg"
              onClick={() => trackEvent('click_whatsapp', { posicao: 'hero' })}
            >
              <IconWhatsapp size={19} />
              {cta.principal.label}
            </AppButton>
            <AppButton href={cta.secundaria.href} variant="ghost" size="lg">
              {cta.secundaria.label}
              <IconArrowRight size={15} />
            </AppButton>
          </div>

          <ul className="hero-notes list-unstyled mb-0">
            {heroi.notas.map((nota) => (
              <li className="hero-note" key={nota}>
                <IconCheckCircle size={16} />
                {nota}
              </li>
            ))}
          </ul>
        </div>
      </Container>
    </header>
  );
}

export default Hero;
